<section class="orders-page">
  <div class="page-heading">
    <div><p>{{ isInternalSales ? 'Point of sale history' : 'Order operations' }}</p><h2>{{ isInternalSales ? 'Internal Sales' : 'Orders' }}</h2><span>{{ isInternalSales ? 'Sales completed directly from business inventory.' : 'Manage customer and marketplace orders.' }}</span></div>
    <button class="secondary" type="button" [disabled]="isLoading" (click)="loadOrders()"><span class="material-symbols-outlined">refresh</span>{{ isLoading ? 'Loading...' : 'Refresh' }}</button>
  </div>

  @if (successMessage) { <p class="state success">{{ successMessage }}</p> }
  @if (errorMessage) { <p class="state error">{{ errorMessage }}</p> }

  @if (isInternalSales) {
    <section class="sales-filter-panel">
      <div class="quick-filters">
        <button type="button" [class.active]="datePreset === 'today'" (click)="applyDatePreset('today')">Today</button>
        <button type="button" [class.active]="datePreset === '7days'" (click)="applyDatePreset('7days')">Last 7 days</button>
        <button type="button" [class.active]="datePreset === 'month'" (click)="applyDatePreset('month')">This month</button>
        <button type="button" [class.active]="datePreset === 'all'" (click)="applyDatePreset('all')">All sales</button>
      </div>
      <div class="date-range">
        <label>From<input type="date" [(ngModel)]="fromDate" (change)="onCustomDateChange()"></label>
        <label>To<input type="date" [(ngModel)]="toDate" (change)="onCustomDateChange()"></label>
      </div>
    </section>
    <section class="sales-summary">
      <article><span>Sales</span><strong>{{ filteredOrders.length }}</strong><small>Selected period</small></article>
      <article><span>Revenue</span><strong>{{ formatAmount(filteredRevenue) }}</strong><small>Total sale value</small></article>
      <article><span>Units sold</span><strong>{{ filteredUnits }}</strong><small>Across all invoices</small></article>
    </section>
  }

  <section class="table-panel">
    <table>
      <thead><tr><th>{{ isInternalSales ? 'Sale' : 'Order' }}</th><th>Product</th><th>Quantity</th><th>Total</th><th>Created</th><th>Status</th><th>{{ isInternalSales ? 'Invoice' : 'Voucher' }}</th></tr></thead>
      <tbody>
        @for (order of filteredOrders; track order.id) {
          <tr>
            <td><strong>{{ order.orderNumber || order.saleInvoice?.number || 'Completed sale' }}</strong></td>
            <td><strong>{{ order.productTitle || 'Order items' }}</strong></td>
            <td>{{ order.quantity }}</td>
            <td><strong>{{ formatAmount(order.totalAmount, order.currency) }}</strong></td>
            <td>{{ order.createdAt ? (order.createdAt | date:'medium') : 'Not available' }}</td>
            <td>
              <div class="status-control">
                <select [name]="'status-' + order.id" [(ngModel)]="selectedStatuses[order.id]" [disabled]="!canUpdateOrders || busyOrderId === order.id">
                  @for (status of statuses; track status) { <option [value]="status">{{ status }}</option> }
                </select>
                @if (canUpdateOrders) { <button class="icon-button" type="button" title="Update order status" [disabled]="busyOrderId === order.id || selectedStatuses[order.id] === statusName(order.status)" (click)="updateStatus(order)"><span class="material-symbols-outlined">check</span></button> }
              </div>
            </td>
            <td>@if (isInternalSales) { <button class="voucher-button" type="button" [disabled]="busyOrderId === order.id" (click)="openInvoice(order)"><span class="material-symbols-outlined">picture_as_pdf</span>{{ order.saleInvoice?.number || (busyOrderId === order.id ? 'Preparing...' : 'Sale invoice') }}</button> } @else { <button class="voucher-button" type="button" [disabled]="busyOrderId === order.id" (click)="openVoucher(order)"><span class="material-symbols-outlined">picture_as_pdf</span>{{ order.purchaseVoucher?.number || (busyOrderId === order.id ? 'Preparing...' : 'Purchase voucher') }}</button> }</td>
          </tr>
        } @empty {
          <tr><td colspan="7" class="empty">{{ isLoading ? 'Loading orders...' : (isInternalSales ? 'No sales found for the selected dates.' : 'No orders found.') }}</td></tr>
        }
      </tbody>
    </table>
  </section>
</section>
